import { useState, useCallback } from 'react';

const YouTubeFacade = ({ videoId, embedUrl, heading, caption, title }) => {
  const [loaded, setLoaded] = useState(false);

  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  const iframeSrc = embedUrl || `https://www.youtube-nocookie.com/embed/${videoId}?cc_load_policy=1`;

  const handleActivate = useCallback(() => setLoaded(true), []);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setLoaded(true);
    }
  }, []);

  return (
    <div className="video-embed-component" data-testid={`video-${videoId}`}>
      {heading && <h3 className="video-heading">{heading}</h3>}
      <div className="video-wrapper">
        {!loaded ? (
          <div
            className="video-facade"
            onClick={handleActivate}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-label={`Play video: ${title || heading}`}
          >
            <img
              src={thumbnailUrl}
              alt={title || heading || 'Video thumbnail'}
              className="video-thumbnail"
              loading="lazy"
            />
            <div className="video-play-button" aria-hidden="true">
              <svg viewBox="0 0 68 48" width="68" height="48">
                <path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="#212121" fillOpacity="0.8"/>
                <path d="M45 24L27 14v20" fill="#fff"/>
              </svg>
            </div>
          </div>
        ) : (
          <iframe
            src={`${iframeSrc}${iframeSrc.includes('?') ? '&' : '?'}autoplay=1`}
            title={title || heading || 'Video'}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="video-iframe"
          />
        )}
      </div>
      {caption && <p className="video-caption">{caption}</p>}
    </div>
  );
};

export default YouTubeFacade;
